
import { NewContractSchemaWithPlan, NewContractSchemaWithoutPlan } from '@weft/types';
import { oz } from '@weft/utils';

export const CreateContractsRequestSchema = oz.discriminatedUnion('creationType', [
  NewContractSchemaWithPlan,
  NewContractSchemaWithoutPlan,
]).openapi('CreateContractsRequest');

export type CreateContractsRequestPayload = oz.infer<typeof CreateContractsRequestSchema>;